import React from "react";
import { BottomDrawer, DimmedOverlay, useFade } from "web-ui";
import { LegacyButton as Button } from "web-ui/legacy";

import styles from "../styles/ConfirmationDrawer.module.scss";

export const ConfirmationDrawer = ({
  cancelText,
  confirmText,
  displayInformation,
  isVisible,
  onDismiss,
  onConfirm,
  usePrimaryButtonAsConfirm,
}: {
  cancelText: string;
  confirmText: string;
  displayInformation: React.ReactNode;
  isVisible: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  usePrimaryButtonAsConfirm?: boolean;
}) => {
  const fadeRef = React.useRef<HTMLDivElement>(null);
  useFade({ animateOnMount: true, isVisible, ref: fadeRef });

  // We consider the bottom button the primary button since it is a more
  // distinct looking button than the top button
  const handleTopButton = () => {
    if (!usePrimaryButtonAsConfirm) {
      onConfirm();
    }
    onDismiss();
  };
  const handleBottomButton = () => {
    if (usePrimaryButtonAsConfirm) {
      onConfirm();
    }
    onDismiss();
  };

  const topButtonText = usePrimaryButtonAsConfirm ? cancelText : confirmText;
  const bottomButtonText = usePrimaryButtonAsConfirm ? confirmText : cancelText;

  return isVisible ? (
    <div className={styles["overlay"]} ref={fadeRef}>
      <DimmedOverlay />
      <BottomDrawer
        animateOnMount={true}
        className={styles["drawer"]}
        isVisible={true}
        onDismiss={onDismiss}
      >
        <div className={styles["content-container"]}>
          <img
            alt=""
            className={styles["duo"]}
            src="/images/duo_detective.svg"
          />
          {displayInformation}
        </div>
        <div className={styles["button-container"]}>
          <Button
            className={styles["button"]}
            color="macaw"
            onClick={handleTopButton}
            variant="stroke"
          >
            {topButtonText}
          </Button>
          <Button
            className={styles["button"]}
            color="macaw"
            onClick={handleBottomButton}
            variant="solid"
          >
            {bottomButtonText}
          </Button>
        </div>
      </BottomDrawer>
    </div>
  ) : null;
};
